'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('ta-semantic-ui/semantic/dist/components/image.css');

require('../style/CopyrightNotice.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyrightNotice = function CopyrightNotice(props) {
  return _react2.default.createElement(
    'a',
    { href: '//www.' + props.secondLevelDomainName + '.ch/',
      className: 'CopyrightNotice ' + (props.inverted ? 'inverted' : '') },
    ' ',
    _react2.default.createElement('img', {
      src: '//interaktiv.tagesanzeiger.ch/static/icons/' + props.secondLevelDomainName + (props.inverted ? '-inverted' : '') + '.svg',
      alt: '',
      className: 'ui mini middle aligned right spaced image' }),
    _react2.default.createElement(
      'small',
      null,
      '\xA9 ',
      props.year,
      ' ',
      props.name
    )
  );
};

CopyrightNotice.propTypes = {
  secondLevelDomainName: _react2.default.PropTypes.string,
  year: _react2.default.PropTypes.number,
  inverted: _react2.default.PropTypes.bool,
  name: _react2.default.PropTypes.string
};

CopyrightNotice.defaultProps = {
  secondLevelDomainName: 'tagesanzeiger',
  year: function () {
    return new Date(Date.now()).getFullYear();
  }(),
  inverted: false,
  name: 'Tages-Anzeiger'
};

exports.default = CopyrightNotice;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-copyright-notice/dist/index.js
// module id = 196
// module chunks = 0